import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../assets/images/right_l.png';
import _imports_1 from '../../../assets/images/left.png';
import _imports_2 from '../../../assets/images/right.png';

const _withScopeId = n => (_pushScopeId("data-v-d493bc38"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "course-wrapper"
};
const _hoisted_2 = {
  class: "tab-wrapper"
};
const _hoisted_3 = {
  key: 0,
  class: "tab-content"
};
const _hoisted_4 = {
  class: "tab-list"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  key: 1
};
const _hoisted_7 = {
  class: "more-btn"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "更多", -1));

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));

const _hoisted_10 = [_hoisted_8, _hoisted_9];
const _hoisted_11 = {
  class: "course-card-list"
};

const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"custom-nav\" data-v-d493bc38><button class=\"custom-prev2\" data-v-d493bc38><img src=\"" + _imports_1 + "\" alt=\"\" data-v-d493bc38></button><button class=\"custom-next2\" data-v-d493bc38><img src=\"" + _imports_2 + "\" alt=\"\" data-v-d493bc38></button></div>", 1);

const _hoisted_13 = {
  key: 1,
  class: "no-data"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CommonTitle = _resolveComponent("CommonTitle");

  const _component_CourseCard = _resolveComponent("CourseCard");

  const _component_SwiperSlide = _resolveComponent("SwiperSlide");

  const _component_Swiper = _resolveComponent("Swiper");

  const _component_Empty = _resolveComponent("Empty");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_CommonTitle, null, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($props.menu && $props.menu.module_name || 'MOOC'), 1)]),
    _: 1
  }), _createElementVNode("div", _hoisted_2, [$data.typeList.length ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.typeList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["tab-item", $data.typeId === item.id && 'active']),
      onClick: $event => $options.searchCourseList(item.id)
    }, _toDisplayString(item.name), 11, _hoisted_5);
  }), 256))])])) : (_openBlock(), _createElementBlock("div", _hoisted_6)), _createElementVNode("div", _hoisted_7, [_createElementVNode("a", {
    onClick: _cache[0] || (_cache[0] = (...args) => $options.handleMore && $options.handleMore(...args))
  }, _hoisted_10)])]), _createElementVNode("div", _hoisted_11, [$data.homeCourseList.length ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createVNode(_component_Swiper, {
    watchSlidesProgress: true,
    slidesPerView: "4",
    spaceBetween: 24,
    loop: true,
    navigation: {
      nextEl: '.custom-next2',
      prevEl: '.custom-prev2'
    },
    modules: $data.modules,
    class: "course-list"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.homeCourseList, (course, index) => {
      return _openBlock(), _createBlock(_component_SwiperSlide, {
        key: course.id
      }, {
        default: _withCtx(() => [_createVNode(_component_CourseCard, {
          class: "home-course-card",
          "course-data": course,
          "show-label": true,
          userInfo: $props.userInfo,
          authType: $data.authType
        }, null, 8, ["course-data", "userInfo", "authType"])]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  }, 8, ["navigation", "modules"]), _hoisted_12], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(_component_Empty)]))])]);
}